module.exports = __webpack_public_path__ + "img/tfuel.1bce977e.svg";